import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { switchMap, map, withLatestFrom } from 'rxjs/operators';

import {
  FilterUsers,
  FilterUsersSuccess,
  GetFilterColumns,
  GetFilterColumnsSuccess,
  EFilterUsersActions
} from '../actions/filter-user.actions';
import { getAutocompleteUsers } from '../selectors/filter-users.selector';
import { FilterUsersService } from '../../services/filter-users.service';
import { IAppState } from 'app/IAppState';

@Injectable()
export class FilterUsersEffects {

  getFilterColumns$ = createEffect(() =>
    this._actions$.pipe(
      ofType<GetFilterColumns>(EFilterUsersActions.GetFilterColumns),
      switchMap(() => this._filterUsersServices.getFilterColumns()),
      switchMap((filterColumns: string[]) => of(new GetFilterColumnsSuccess(filterColumns)))
    )
  );
  filterUsers$ = createEffect(() =>
    this._actions$.pipe(
      ofType<FilterUsers>(EFilterUsersActions.FilterUsers),
      withLatestFrom(this._store.pipe(select(getAutocompleteUsers))),
      map(([action]) => ({
        ...action.payload
      })),
      switchMap(payload => this._filterUsersServices.filterUsers(payload.filterColumn, payload.valueToSearch)
        .pipe(
          map((users: ISpecificUser[]) => new FilterUsersSuccess(users))
        )
      )
    )
  );

  constructor(
    private _filterUsersServices: FilterUsersService,
    private _actions$: Actions,
    private _store: Store<IAppState>
  ) {
  }

}
